import SimpleArrowButton from '@bits/SimpleArrowButton';
import Info from '@components/bits/icons/Info';
import SimpleBlockContent from '@components/bits/SimpleBlockContent';
import TypeValueRow from '@components/bits/TypeValueRow';
import { useRouter } from 'next/router';
import React, { FunctionComponent, useState } from 'react';

import styles from './index.module.scss';
type Props = {
  campaign;
};
const CampaignCardInfo: FunctionComponent<Props> = ({ campaign }) => {
  const [showInfo, setShowInfo] = useState(false);
  
  const router = useRouter();

  if (!campaign || !campaign.content) {
    return <span>{null}</span>;
  }

  const { content: currentElement  } = campaign;

  const { title, elements, ingress, cta, infoButtonText, info } = currentElement;
  const gotoDealerspage = (): void => {
    const slug = cta?.route?.slug?.current;
    const link = cta?.link;

    if (slug) {
      router.push(
        {
          pathname: slug,
        },

        undefined,
        { shallow: false }
      );
    } else if (link) {
      router.push(
        {
          pathname: link,
        },

        undefined,
        { shallow: false }
      );
    }
  };

  const toggleVisible = (): void => {
    setShowInfo(!showInfo);
  };

  return (
    <div className={styles.root}>
      <div className={styles.card}>
        <div className={styles['_right']}>
          <div className={styles['_top']}>
            <h4 className="bold">{title}</h4>
            <SimpleBlockContent data={ingress} />
          </div>
          <div className={styles['_content']}>
            {elements?.map((val, key) => {
              return <TypeValueRow key={key} type={val.desc} value={val.value} />;
            })}
          </div>
          <div
            className={`${styles['_info']} ${showInfo ? styles['active'] : ''}`}
            onMouseEnter={() => setShowInfo(true)}
            onMouseLeave={() => setShowInfo(false)}
            onTouchStart={toggleVisible}>
            <Info />
            <button>{infoButtonText}</button>
            <div className={styles['_modal']}>
              <SimpleBlockContent data={info} />
            </div>
          </div>
          <div className={styles['_ctas']}>
            <SimpleArrowButton onClick={() => gotoDealerspage()} text={cta.title} color={'black'} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CampaignCardInfo;
